export const HIDELIST_CONTRACTS = [
  '0x06012c8cf97bead5deae237070f9587f8e7a266d', // CryptoKitties
  '0x79986af15539de2db9a5086382daeda917a9cf0c', // Cryptovoxels
  '0x88b48f654c30e99bc2e4a1559b4dcf1ad93fa656', // Opensea Collections
  '0x495f947276749ce646f68ac8c248420045cb7b5e', // Opensea Collection
];
